function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import moment from 'moment';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
// import * as PDFDocument from 'pdfkit'
// import * as blobStream from "blob-stream"
import { test1 } from '../../../../pdfkit/test-pdfkit';
import jsPDF from 'jspdf';
import './panel-cv-pdf.scss';
var PanelCvPdfComponentCtrl = /*#__PURE__*/function () {
  PanelCvPdfComponentCtrl.$inject = ["$element", "$log", "$timeout", "AccesoDatos"];
  function PanelCvPdfComponentCtrl($element, $log, $timeout, AccesoDatos) {
    _classCallCheck(this, PanelCvPdfComponentCtrl);
    _defineProperty(this, "$loading", false);
    _defineProperty(this, "history", {
      list: [],
      show: true
    });
    this.$element = $element;
    this.$log = $log;
    this.$timeout = $timeout;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(PanelCvPdfComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.$log.info('[PanelCvPrintComponentCtrl] onInit');
      this._leerCV().then(function () {
        _this.AccesoDatos.Datos_Client.tiposParaDocuemntos().then(function (responseTipos) {
          _this.statesStore = responseTipos.estados;
        });
      });
    }
  }, {
    key: "$postLink",
    value: function $postLink() {
      $('body').css('overflow', 'auto');
    }
  }, {
    key: "_leerCV",
    value: function _leerCV() {
      var _this2 = this;
      this.$loading = true;
      return this.AccesoDatos.GestionCurr_CLIENT.leerCv(this.cv.cv.form_id, this.cv.cv.idcv).then(function (reportResponse) {
        _this2.report = reportResponse;
        _this2.history.list = reportResponse.history.list;
        _this2.$loading = false;
      });
    }
  }, {
    key: "_refreshcv",
    value: function _refreshcv() {
      this.report = null;
      this._leerCV();
    }
  }, {
    key: "toggleHistory",
    value: function toggleHistory() {
      this.history.show = !this.history.show;
    }
  }, {
    key: "fichaPdf",
    value: function fichaPdf() {
      var _this3 = this;
      var doc = new jsPDF({
        orientation: 'p',
        unit: 'pt',
        format: 'a4',
        putOnlyUsedFonts: true
      });
      doc.setFontSize(10);
      doc.text("Application Date: ".concat(moment(this.cv.cv.fcalta).format('lll')), 20, 20);
      doc.html('<hr/>');
      doc.setLineWidth(0.4);
      doc.line(20, 25, 200, 25);
      doc.text(['hola', 'segunda', 'terceraterceraterceraterceraterceratercera terceraterceraterceraterceraterceratercera terceraterceraterceraterceraterceratercera terceraterceraterceraterceraterceratercera'], 20, 50, {
        lineHeightFactor: 2
      });
      var lines = doc.splitTextToSize('terceraterce \nraterceraterceraterce ratercera terceraterceratercer aterceraterceratercera terceraterceratercera terceratercerater cera terceraterceraterc eraterceratercerater cera', 190);
      console.log('---->', lines);
      doc.text(lines, 20, 300);
      doc.text('=======', 20, 370 - 2.5);
      doc.text('=======', 20, 381.25 - 2.5);
      doc.text('=======', 20, 392.5 - 2.5);
      doc.text('=======', 20, 403.75 - 2.5);
      doc.text(['uno', 'dos', 'tres', 'cuatro'], 60, 370);
      console.log('===>', doc.getTextDimensions(lines));

      // doc.text(["hola", "segunda", "tercera"], 20, 60)

      // pintar los bloques
      this.report.bloques.forEach(function (b) {
        return _this3.fichaPdfBloque(doc, b);
      });
      window.open(URL.createObjectURL(doc.output('blob')));
    }
  }, {
    key: "fichaPdfBloque",
    value: function fichaPdfBloque(doc, b) {
      var _this4 = this;
      // pintar texto del bloque

      // pintar las preguntas
      b.pregsList.forEach(function (p) {
        return _this4.fichaPdfPreg(doc, b, p);
      });
    }
  }, {
    key: "fichaPdfPreg",
    value: function fichaPdfPreg(doc, b, preg) {
      // texto preg
      doc.html("<span>".concat(preg.q.texto_en, "</span>"));
      console.log('preg ---> ', preg.q.texto_en);
    }
  }, {
    key: "fichaPdf2",
    value: function fichaPdf2() {
      var docPdf = new jsPDF();
      // doc.text(`Application Date: ${moment(this.cv.cv.fcalta).format('lll')}`, 20, 20);

      var _elDoc = this.$element.find('.print__content');
      if (_elDoc.length) {
        docPdf.html(_elDoc[0]);
      }

      // doc.save(`Cv-${this.cv.cv.idcv}.pdf`);

      docPdf.autoPrint();
      var _blob = docPdf.output('blob');
      _blob.name = 'foooo';
      window.open(URL.createObjectURL(_blob));
    }
  }, {
    key: "fichaPdf4",
    value: function fichaPdf4() {
      test1.testdoc();
    }

    // fichaPdf3() {

    //     const lorem = "TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM "

    //     var doc = new PDFDocument()

    //     doc.registerFont('Roboto', 'fonts/Roboto-Regular.ttf');
    //     doc
    //         .font('Roboto')
    //         .text('And here is some wrapped text...', 100, 300)
    //         .fontSize(13)
    //         .moveDown()
    //         .text(lorem, {
    //             width: 412,
    //             align: 'justify',
    //             indent: 30,
    //             columns: 2,
    //             height: 300,
    //             ellipsis: true
    //         });

    //     doc.addPage();

    //     const stream = doc.pipe(blobStream());

    //     window.open(URL.createObjectURL(stream.toBlob()))
    // }
  }]);
}();
angular.module('candidato').component('panelCvPdf', {
  bindings: {
    cv: '<'
  },
  controller: PanelCvPdfComponentCtrl,
  // templateUrl: "panel-cv-pdf.component.html",
  template: require('./panel-cv-pdf.component.html')
});